import React, { useState, useEffect } from "react";
import { Typography, Table, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import Pageloader from "../../../components/loader";
import ModalBody from "../../../components/modal/universialModal/modalBody";
import Edit from "./formBody/edit";
import { dataKey, userhasPermissionHelper } from "../../../utils/Helpers";
// import TriggersFilters from "./filters";
import * as actionPage from "../../../redux/actions/triggers.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../../utils/constants/app";

const { Title } = Typography;
const pageName = "Triggers";
const pageLink = "triggers";

const TriggersListing = (props) => {
  const [postData, setPostData] = useState(null);
  const [modalOpen, setModalOpen] = useState(null);

  useEffect(() => {
    if(props.pageFilter) {
      postLists(props.pageFilter)
    }
  }, [props.pageFilter]);

  useEffect(() => {
    setPostData(dataKey(props.pageData));
  }, [props.pageData]);

  const postLists = async (data) => {
    const newData = {
      ...data,
    };
    const { searchOption, ...rest } = newData;
    try {
      // if (rest) {await props.actionPage.listAction(rest)}
      await props.actionPage.listAction(rest)
    } catch (e) {}
  };


   // Modal Start **********************
   const modalCancel = () => {
    setModalOpen(null)
  }

  const modalonAction = (value=null, type=null, formBody=null) => {
    setModalOpen(()=>({
      modal: true,
      value: value,
      type: type,
      formBody: formBody,
    }))
  }

  const onCreateAction = async (values, info) => {
    console.log('values, info', values, info)

    if (info?.type === 'edit') {
      const newData = {
        ...values,
        triggerId: info?.value?.id
      }
      console.log('edit', values, info, newData)
      // return null
      try {
        await props.actionPage.patchAction(newData).then((res)=>{
          {message.success(res.data.message)}
        });
        postLists(props.pageFilter)
        modalCancel()
      } catch {}
    }
  }
  // Modal End **********************

  let columns = [
    {
      title: "Notification Title",
      dataIndex: "notification_title",
      render: (value) => (value || '-'),
    },
    {
      title: "Notification Message",
      dataIndex: "notification_message",
      render: (value) => (value || '-'),
    },
    {
      title: "Dialogue Title",
      dataIndex: "dialogue_title",
      render: (value) => (value || '-'),
    },
    {
      title: "Dialogue Message",
      dataIndex: "dialogue_message",
      render: (value) => (value || '-'),
    },
    {
      title: "Active",
      dataIndex: "is_active",
      render: (value) => (value === true?'True':'False'),
    },
    {
      title: "Break",
      dataIndex: "is_break",
      render: (value) => (value === true?'True':'False'),
    },
    {
      title: "Duration",
      dataIndex: "break_duration",
      render: (value) => (value || '-'),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (value) => (value || '-'),
    },
  ];

  if (userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_TRIGGERS)) {
    columns.push({
      title: "Action",
      render: (value, record) => (
        <a onClick={() => modalonAction(record, "edit", Edit)}>
          <EditOutlined />
        </a>
      ),
    });
  }

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{`${pageName}`}</Title>
      </div>
        {/* <TriggersFilters /> */}
      <div className="p-content">
        {props.pageLoading ? <Pageloader /> : <>
          <Table
            dataSource={postData}
            columns={columns}
            pagination={false}
          />
        </>}
      </div>
      {modalOpen && <ModalBody modalOpen={modalOpen} Loading={props.pageLoading} modalCancel={modalCancel} onCreateAction={onCreateAction}/>}
    </div>
  );
};

const mapStateToProps = (state) => {
return {
  pageData: state.TriggersReducer?.initialData,
  pagePagination: state.TriggersReducer?.initialPagination,
  pageLoading: state.TriggersReducer?.initialLoading,
  pageFilter: state.TriggersReducer?.initialFilter,
  permissions: state.PermissionReducer.permissions,
};
};
const mapDispatchToProps = (dispatch) => {
return {
  actionPage: bindActionCreators(actionPage, dispatch),
};
};

export default connect(mapStateToProps, mapDispatchToProps)(TriggersListing);
